import { ReportState } from '../state';

export const setSigned = (state: ReportState, payload: { isSigned: boolean; by: string }) => {
  state.signed = { ...state.signed, ...payload };
};

export const toggleSigned = (state: ReportState) => {
  state.signed.isLocked = !state.signed.isLocked;
};
